import VBActive from './icon-svg/VBActive.svg'
import VBInActive from './icon-svg/VBInActive.svg'
import VBDisabled from './icon-svg/VBDisabled.svg'

import { MatButton } from 'components/buttons'

const VideoBackgroundIconButton: React.FC<{
    active?: boolean
    onClick: React.MouseEventHandler<HTMLButtonElement>
    alert?: boolean
}> = ({ active, onClick, alert }) => (
    <MatButton
        id='video-background-icon-button'
        onClick={onClick}
        disabled={alert}
        className={`${!alert && active ? '' : 'button-in-active'}`}
        width='56px'
        height='48px'
        borderRadius='48px'
        color={'primary'}
        variant='contained'
    >
        <img src={alert && !active ? VBDisabled : active ? VBActive : VBInActive} alt='vb' />
    </MatButton>
)

export { VideoBackgroundIconButton }
